<template>
  <button class="hotspot" :title="title"><slot></slot></button>
</template>
<script>
import tippy from "tippy.js";

export default {
  props: ["title"],
  mounted() {
    tippy(document.querySelectorAll(".hotspot"), {
      arrow: true
    });
  }
};
</script>

<style lang="scss">
.hotspot {
  height: 24px;
  width: 24px;
  border: none;
  background: hsl(250, 13%, 9%);
  color: #fff;
  font-weight: bold;
  border-radius: 50%;
  box-shadow: 0 0 0 hsla(250, 65%, 49%, 0.4);
  animation: pulse 2s infinite;
  position: absolute;
  padding: 0;
  margin: 0;
  font-size: 0.775rem;
  cursor: pointer;

  &:hover {
    animation: none;
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 hsla(250, 65%, 49%, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px hsla(250, 65%, 49%, 0);
  }
  100% {
    box-shadow: 0 0 0 0 hsla(250, 65%, 49%, 0);
  }
}

.hotspot h4 {
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1;
}

.template {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/Tippy.vue